import { createSelector } from "@reduxjs/toolkit";
import { ITopBarReducerState } from "./reducer/types";

const selectTopBarState = (state: any): ITopBarReducerState => state.topBar;

const makeSelectCustomBackPath = () => createSelector(selectTopBarState, (state) => state.customBackPath);
const makeSelectPageName = () => createSelector(selectTopBarState, (state) => state.pageName);

export { makeSelectCustomBackPath, makeSelectPageName };
